export default "__VITE_ASSET__BVagthM8__"